import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { db } from "../firebase.js";
import { doSignOut } from "./auth.js";
import { useAuth } from "./authContext";
import firebase from "firebase/compat/app";


import { CalendarMonth, ComputerSharp } from '@mui/icons-material';
import { FaWrench } from 'react-icons/fa';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';



import { firebaseConfig } from './firebase'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AddIcon from '@mui/icons-material/Add';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import BusinessIcon from '@mui/icons-material/Business';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import GavelIcon from '@mui/icons-material/Gavel';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CottageIcon from '@mui/icons-material/Cottage';
import PaidIcon from '@mui/icons-material/Paid';
import ListingItem from "../components/ListingItem.jsx";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import NewPatientModal from './NewPatientModal.jsx.jsx'
import { Button } from 'react-bootstrap';
import LockIcon from '@mui/icons-material/Lock';
import SpeedIcon from '@mui/icons-material/Speed';
import SupportIcon from '@mui/icons-material/Support';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";
import BubbleChartRoundedIcon from "@mui/icons-material/BubbleChartRounded";
import WalletRoundedIcon from "@mui/icons-material/WalletRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import HouseIcon from '@mui/icons-material/House';
import GppGoodIcon from '@mui/icons-material/GppGood';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PieChartIcon from '@mui/icons-material/PieChart';
import SearchIcon from '@mui/icons-material/Search';
import CalculateIcon from '@mui/icons-material/Calculate';
import AddHomeIcon from '@mui/icons-material/AddHome';
import SchoolIcon from '@mui/icons-material/School';
import GroupIcon from '@mui/icons-material/Group';
import PeopleIcon from '@mui/icons-material/People';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import axios from 'axios';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { MapContainer, Popup, Marker, TileLayer } from "react-leaflet";
import Contact from "../components/Contact.jsx";
import {
  FaBath,
  FaBed,
  FaChair,
  FaMapMarkerAlt,
  FaParking,
  FaShare,
} from "react-icons/fa";
import Dmedashboard from "./dmedashboard.jsx";

import { getAuth } from "firebase/auth";
import StateModal from "./StateModal.jsx";
import { Chip } from "@mui/material";
import TenantModal from "./TenantModal.jsx";
import UpsellModal from "./UpsellModal.jsx";
import ProfileComponent from "./ProfileComponent.jsx";
import { CreditCard } from "@mui/icons-material";

firebase.initializeApp(firebaseConfig);

const DealCalculator = () => {
  const auth = getAuth();


  const [listings, setListings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [listing, setListing] = useState(null);
  const [shareLinkCopied, setShareLinkCopied] = useState(false);
  const [contactLandlord, setContactLandlord] = useState(false);
  const [lastFetchedListing, setLastFetchListing] = useState(null);
  const { currentUser } = useAuth()
  const [user, setUser] = useState(null);

  


  useEffect(() => {
    setTimeout(()=>{

    firebase
      .firestore()
      .collection("users")
      .doc(currentUser.uid)
      .get()
      .then((snapshot) => {
        if (snapshot.exists) {
          setUser(snapshot.data());
          console.log("USERID", currentUser.uid)
          console.log("USER", user)

        } else {
          console.log("does not exist");
        }
      });
    }, 1000)
}, []);


const OpenModalButton = () => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <button onClick={handleOpen}>Housing Authority</button>
      <StateModal open={open} onClose={handleClose} />
    </>
  );
};
const OpenModalButton2 = () => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <button onClick={handleOpen}>Tenant Lookup</button>
      <TenantModal open={open} onClose={handleClose} />
    </>
  );
};
const FMRUpsell = () => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <button onClick={handleOpen}>FMR Explorer</button>
      <UpsellModal open={open} onClose={handleClose} />
    </>
  );
};
const DealExplorerUpsell = () => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <button onClick={handleOpen}>Deal Explorer</button>
      <UpsellModal open={open} onClose={handleClose} />
    </>
  );
};
const MarketResearchUpsell = () => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <button onClick={handleOpen}>Market Research</button>
      <UpsellModal open={open} onClose={handleClose} />
    </>
  );
};




  if (!user) {
    return <div></div>
  } else
  return (
    <div className="offer" >
      {/* <h1 className="offer__title4">Deal Calculator</h1> */}

      <div style={{ display: "flex", height: "100vh"}}>
     <Sidebar
    style={{
      backgroundColor: '#000222',
      flex: '0 0 250px', // Fixed width for the sidebar
    }}
  >
            <Menu style={{ backgroundColor: '#000222' }}>
              <MenuItem>
                <div style={{ marginLeft: -43, backgroundColor: 'white' }}>
                  <img
                    src="https://i.ibb.co/s2dBvDt/elevate.png"
                    alt="logo"
                    className="ml-4 mt-12 -p-4 "
                    width={300}
                  ></img>
                </div>
              </MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white', marginTop: '50px' }} onClick={() => window.location = 'fmrexplorer'} icon={<LocationOnIcon />}> FMR Explorer </MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'propertylookup'} icon={<SearchIcon />}>Market Research</MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'dealcalculator'} icon={<CalculateIcon />}>Deal Calculator</MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'dealexplorer'} icon={<AddHomeIcon />}>Deal Explorer</MenuItem>

              
<MenuItem
  style={{
    backgroundColor: '#000222',
    color: 'white',
    fontSize: 18,
    display: 'flex',
    alignItems: 'center',
  }}
  onClick={() => window.location = 'dealexplorerai'}
>
  <span style={{ display: 'flex', alignItems: 'center' }}>
    <AutoAwesomeIcon fontSize="small" style={{ marginRight:18}}/>
    Deal Explorer Ai
    <Chip
      label="beta"
      size="small"
      style={{
        backgroundColor: 'white',
        color: '#000222',
        fontSize: 10,
        fontWeight: 600,
        height: 18,
        borderRadius: 9999,
        marginLeft:4
      }}
    />
  </span>
</MenuItem>   

              <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'skiptrace'} icon={<VisibilityIcon />}>Skip Trace</MenuItem>

<MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'rentcast'} icon={<SpeedIcon />}>Rent Reveal</MenuItem>
                <MenuItem style={{ color: 'white', backgroundColor: '#000222' }} icon={<HouseIcon />}> <OpenModalButton /> </MenuItem>
                <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<EmojiPeopleIcon />}> <OpenModalButton2 /> </MenuItem>
                <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<SupportIcon />} onClick={() => window.open('https://elevatecoachingrei.steadilypartner.com/', "_blank")}> Landlord Insurance </MenuItem>

              <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'community'} icon={<PeopleIcon />}>Community Hub</MenuItem>
                <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<ComputerSharp />} onClick={() => window.open('https://section8guys.com/training', "_blank")}> Next Webinar </MenuItem>

              <SubMenu label="Book a Session" style={{ backgroundColor: '#000222', color: 'white' }} icon={<CalendarMonth />}>
               
                <MenuItem icon={<PeopleIcon />} style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://calendly.com/elevaterei/googlemeet?back=1&month=2025-01', "_blank")}>
                  1-on-1s
                </MenuItem>
                <MenuItem icon={<BusinessIcon />} style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://calendly.com/elevaterei/inoffice?back=1&month=2025-01', "_blank")}>
                  Day in the Office
                </MenuItem>
                <MenuItem icon={<DirectionsCarFilledIcon />} style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://calendly.com/elevaterei/ridealong?back=1&month=2025-01', "_blank")}>
                  Ride Along
                </MenuItem>
              </SubMenu>
             
    
              <SubMenu label="Investor Solutions" style={{ backgroundColor: '#000222', color: 'white' }} icon={<BusinessIcon />}>
                              <MenuItem icon={<LockIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Asset Protection </MenuItem>
                                              <MenuItem icon={<AttachMoneyIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Business Funding </MenuItem>
                <MenuItem icon={<CreditScoreIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Credit Builder </MenuItem>
                <MenuItem icon={<FaWrench />} onClick={() => window.open('https://elevatecoachingrei.thecreditbrothers.com/learn-more?entry_source=elevatecoachingrei', "_blank")}> Credit Repair </MenuItem>
                <MenuItem icon={<AddIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}>Entity Formation </MenuItem>
                <MenuItem icon={<RequestQuoteIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Taxes </MenuItem>
              </SubMenu>
                <MenuItem style={{ color: 'white', backgroundColor: '#000222' }} onClick={() => window.open('https://lendsimpli.com/elevate/', "_blank")} icon={<CurrencyExchangeIcon />}> Property Loans </MenuItem>
                              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://www.skool.com/elevate-wsection-8-8185', "_blank")} icon={<SchoolIcon />}>Skool Community</MenuItem>

              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<LogoutRoundedIcon />} onClick={() => doSignOut({ callbackUrl: '/', redirect: true })}> Logout </MenuItem>
              <div style={{ ...styles.container1, backgroundColor: '#000222' }}>
                <ProfileComponent user={user} />
              </div>
            </Menu>
          </Sidebar>
      
      
        <>
          <main>
          <h1 className="offer__title2">Deal Calculator</h1>
          <h4 className="offer__title80">Welcome to the Deal Calculator! Click Add Property to get Started!</h4>
            <div style={{  display:'flex', justifyContent:'center', margin:'auto', marginLeft:'50px', marginTop:'-70px' }}>

          
            
          <Dmedashboard />
        </div>
            
           
         
           
          </main>
          
        </>
     
    </div>
    </div>
  );
};

export default DealCalculator;

const styles = {
  container: {
    margin: '20px auto',
    maxWidth: '600px',
    fontFamily: 'Arial, sans-serif',
  },
  list: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    width:'100%',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  listItem: {
    padding: '12px 16px',
    cursor: 'pointer',
    borderBottom: '1px solid #ddd',
    backgroundColor: '#fff',
    width:'100%',
    transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
  },
  listItemHover: {
    backgroundColor: '#f7f7f7',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  centerScreen: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    
    minHeight: '100vh'
  },
  container1: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    marginTop:'0px'
  },
  profile: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#000222',
    padding: '10px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  profileAvatar: {
    width: '52px',
    height: '52px',
    borderRadius: '50%',
    marginRight: '21px',
  },
  profileName: {
    fontSize: '17px',
    fontWeight: 'bold',
    color: 'white',
    margin: 0,
  },
  profileHandle: {
    fontSize: '11px',
    color: 'white',
    margin: 0,
  },
  
};